'use client';

import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n/client';
import { useEffect } from 'react';

export default function I18nProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    // Update the data-lang attribute whenever language changes
    const updateLangAttribute = () => {
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('data-lang', i18n.language);
      }
    };

    // Set initially
    updateLangAttribute();

    // Listen for language changes
    i18n.on('languageChanged', updateLangAttribute);

    return () => {
      i18n.off('languageChanged', updateLangAttribute);
    };
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
